import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RedirectProps {
  to: string;
}

/**
 * The URL needs to be absolute, the redirect does *not* work proper with relative paths.
 */
const Redirect: FC<RedirectProps> = ({ to }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to);
  }, []);

  return <>redirect</>;
};

export { Redirect };
